import { UTM_TRACKING_PARAMS } from '../constants';

export const getUtmTrackingParamsFromCookie = (): Record<string, string> => {
  const result: Record<string, string> = {};

  const cookies = document.cookie.split('; ');

  cookies.forEach((cookie) => {
    const [key, value] = cookie.split('=');

    if (UTM_TRACKING_PARAMS.includes(key) && value) {
      result[key] = decodeURIComponent(value);
    }
  });

  return result;
};
